var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users-and-groups-wrapper card"},[_c('page-header',{attrs:{"title":"Edit User","breadcrumbText":"Dashboard >> Settings >> Users and Groups >> Edit User"}}),_c('edit-user-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }